import Layout from '@/components/Layout';
import TOSBlock from '@/_content/blocks/terms-of-service/TOS.mdx';
import useConfig from '@/hooks/useConfig';
import Meta from '@/components/Meta';

export default function TOSPage() {
  const { t } = useConfig();

  return (
    <Layout>
      <Meta title={t('tos.meta.title')} description={t('tos.meta.description')} />
      <h1>{ t('tos.title') }</h1>
      <TOSBlock />
    </Layout>
  );
}
